<template>
  <div class="create-ticket">
    <div class="panel panel-primary">
      <div class="panel-heading">用户信息</div>
      <div class="tab-content">
        <form class="form-horizontal">
          <div class="form-group">
            <label for="inputEmail3" class="col-sm-2 control-label">会员卡号</label>
            <div class="col-sm-10">
              <input
                disabled
                type="text"
                class="form-control"
                id="inputEmail3"
                placeholder="会员卡号"
                v-model="user.profile.vipID"
              >
            </div>
          </div>
        </form>
        <user :user="user" @onPhoneInput="onPhoneInput"></user>

        <user-list :users="users" @onRowClick="onRowClick"></user-list>
      </div>
    </div>
    <div class="panel panel-primary">
      <div class="panel-heading">衣单信息</div>
      <div class="tab-content">
        <ticket-info :ticket="ticket"></ticket-info>
      </div>
    </div>
    <div class="panel panel-primary">
      <div class="panel-heading">衣服信息</div>
      <div class="form-horizontal">
        <ticket-clothes
          :items="ticket.clotheRecords"
          mode="editing"
          @onDeleteClick="onClotheDeleteClick"
          @onEditClick="onClotheEditClick"
        ></ticket-clothes>
        <div class="panel panel-success">
          <div class="panel-heading">衣服信息编辑</div>
          <div class="panel-body">
            <ticket-clothe :clothe="editingClothe"></ticket-clothe>
          </div>
          <div class="form-group">
            <div class="col-sm-10 col-sm-offset-2">
              <button class="btn btn-primary" @click="addClothe">添加衣服</button>
              <button class="btn btn-primary" @click="saveClothe">保存修改</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="panel panel-primary">
      <div class="panel-heading">用户操作</div>
      <div class="tab-content">
        <ticket-view :ticket="ticket"></ticket-view>
        <div class="col-sm-4 col-sm-offset-4" style="text-align:center;">
          <div class="btn-group">
            <button class="btn btn-primary" @click="save()" :disabled="isSaving">保存</button>
          </div>
        </div>
      </div>
    </div>

    <modal v-model="dialog.createUser.show" title="提示" size="sm">
      <p>{{dialog.createUser.message}}</p>
      <div slot="footer">
        <button class="btn btn-default" @click="dialog.createUser.show=false">取消操作</button>
        <button class="btn btn-danger" @click="doSave">我已确认</button>
      </div>
    </modal>
  </div>
</template>

<script>
import TicketInfo from '@/components/forms/TicketInfo'
import User from '@/components/forms/User'
import TicketClothes from '@/components/list/TicketClothes'
import UserList from '@/components/list/User'
import TicketClothe from '@/components/forms/TicketClothe'
import * as TYPES from '../store/types'
import TicketView from '@/components/views/Ticket'

import nanoid from 'nanoid'
export default {
  components: {
    TicketInfo,
    User,
    TicketClothes,
    UserList,
    TicketClothe,
    TicketView
  },
  data() {
    return {
      editingClothe: {
        name: '',
        color: {
          text: ''
        },
        price: '',
        brand: {
          text: ''
        },
        flawRecords: []
      },
      dialog: {
        createUser: {
          show: false,
          message: '请确认用户信息！'
        }
      },
      user: {
        profile: {}
      }
    }
  },
  computed: {
    ticket() {
      return this.$store.state.tickets.create.editing
    },
    users() {
      return this.$store.state.users.list.items
    },
    isSaving() {
      return this.$store.state.tickets.create.isSaving
    }
  },
  methods: {
    saveClothe() {
      this.editingClothe = {
        name: '',
        color: {
          text: ''
        },
        price: '',
        brand: {
          text: ''
        },
        flawRecords: []
      }
    },
    save() {
      if (!this.ticket.user.id) {
        this.$store
          .dispatch(TYPES.DO_USER_VIEW, this.user.profile.phone)
          .then(res => {
            if (res.data.ok && res.data.data) {
              console.log('开始保存衣单')
              this.doSave()
            } else {
              this.$confirm({
                title: '信息错误',
                content: '此手机号码未在店内消费过，请确认信息输入正确'
              })
                .then(() => {
                  this.doSave(true)
                })
                .catch(() => {
                  this.$notify('取消开单！')
                })
            }
          })
          .catch(res => {
            console.log(res)
            this.$notify('开单错误')
          })
      } else {
        this.$confirm({
          size: 'md',
          title: '确认开单',
          content: `您将要给用户【${this.ticket.user.profile.name}】开具【${
            this.ticket.clotheRecords.length
          }】件衣服的洗衣单，确认开单？`
        })
          .then(() => {
            this.doSave(false)
          })
          .catch(() => {
            this.$notify('已取消开单！')
          })
      }
    },
    doSave(createUser) {
      this.dialog.createUser.show = false
      if (createUser) {
        if (createUser.vipID) {
          this.$notify({
            type: 'danger',
            content: '普通用户没有会员卡号，请勿填入会员卡'
          })
        }
      }
      const ticket = Object.assign({}, this.ticket)
      ticket.user = this.user
      console.log(ticket)
      this.$store
        .dispatch(TYPES.DO_CREATE_TICKET, ticket)
        .then(res => {
          if (res.data.ok) {
            this.$router.push('/ticket/' + res.data.data.idView)
          } else {
            this.$notify({
              type: 'danger',
              content: res.data.msg
            })
          }
        })
        .catch(res => {
          console.log(ticket)
          this.$notify({
            type: 'danger',
            content: res.data.msg
          })
        })
    },
    onPhoneInput(phone) {
      this.ticket.user = {
        profile: {
          phone: phone
        }
      }
      this.$store.dispatch(TYPES.DO_GET_USER_SEARCH, phone)
    },
    onRowClick(item) {
      this.user = item
    },
    addClothe() {
      if (!this.editingClothe.name || !this.editingClothe.price) {
        this.$notify({
          type: 'danger',
          content: '衣服信息不完整或格式错误'
        })
        return
      }
      const reg = /^[0-9]+$/
      if (!reg.test(this.editingClothe.price)) {
        this.$notify({
          type: 'danger',
          content: '衣服价格请填写数字，不允许包含汉字和【-】等其他特殊符号'
        })
        return
      }
      this.$store
        .dispatch(
          TYPES.DO_ADD_CLOTHE_RECORD_TO_TICKET,
          Object.assign(
            { _id: nanoid(10) },
            Object.assign({}, this.editingClothe)
          )
        )
        .then(res => {
          this.editingClothe = {
            name: '',
            color: '',
            price: '',
            brand: '',
            flaws: []
          }
          this.flawRecords = []
        })
    },
    onClotheDeleteClick(item) {
      this.$store.dispatch(TYPES.DO_REMOVE_CLOTHE_RECORD_FROM_TICKET, item)
    },
    onClotheEditClick(item) {
      this.editingClothe = item
    }
  }
}
</script>

<style scoped>
.tab-content {
  padding: 10px;
}
.tab-content > div {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/CreateTicket.vue